// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1Sm52","inputWrap":"Table_inputWrap__rF4MJ","col":"Table_col__Ao2to","bmiTooltip":"Table_bmiTooltip__1ghbJ"};